import React, { Component } from 'react'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { EditableReactSelect, EditableTextField } from '../common/EditableComponents'
import ModalDialog from '../common/ModalDialog'
import SearchField from '../common/SearchField'

const useStyles = {
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: '20px',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}

class AddEmployeeModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      term: '',
      selected: [],
      dchEmployeesSearch: [],
    }
  }

  componentDidMount() {
    this.filter('')
  }

  handleClick = (event, shopId) => {
    const selectedIndex = this.state.selected.indexOf(shopId)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.state.selected, shopId)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.state.selected.slice(1))
    } else if (selectedIndex === this.state.selected.length - 1) {
      newSelected = newSelected.concat(this.state.selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.selected.slice(0, selectedIndex),
        this.state.selected.slice(selectedIndex + 1),
      )
    }

    this.setState({ selected: newSelected })
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    })
  }

  handleChangeDense = (event) => {
    this.setState({
      dense: event.target.checked,
    })
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  onSearch = (e) => {
    if (e === '' || /^( )*$/.test(e)) {
      this.filter('')
    } else {
      this.filter(e)
    }
  }

  filter(value) {
    const { employeesList = [] } = this.props
    let newList = []
    if (value === '') {
      newList = employeesList
    } else {
      newList = employeesList.filter((s) =>
        (s.firstName ? s.firstName : '')
          .concat(' ')
          .concat(s.lastName ? s.lastName : '')
          .toLowerCase()
          .includes(value.toLowerCase()),
      )
    }
    this.setState({
      dchEmployeesSearch: newList,
    })
  }

  render() {
    const classes = useStyles
    const isSelected = (name) => this.state.selected.indexOf(name) !== -1
    const { forwardedRef, open, close } = this.props

    const { selected, page, dense, rowsPerPage, dchEmployeesSearch } = this.state

    return (
      <Dialog
        title={'Add Employee(s)'}
        ref={forwardedRef}
        open={open}
        onClose={close}
        onOpen={open}
      >
        <DialogTitle>Add Employee(s)</DialogTitle>
        <DialogContent>
          <Grid item xs={12} sm={12}>
            <div className="category-rightside">
              <SearchField
                onSearch={this.onSearch}
                onChange={this.onChangeTerm}
                value={this.state.term}
              />
            </div>
          </Grid>
          <Paper elevation={0} className={classes.paper}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
              aria-label="enhanced table"
            >
              <TableBody>
                {dchEmployeesSearch.map((row, index) => {
                  const isItemSelected = isSelected(row.id)
                  const labelId = `enhanced-table-checkbox-${index}`
                  return (
                    <TableRow
                      hover
                      onClick={(event) => this.handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row" padding="none">
                        {row.name}
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Paper>
        </DialogContent>

        <DialogActions className="container-buttons-adoption-mode">
          <Button onClick={close} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          <Button onClick={() => this.props.startSync(selected)} className="button-blue-and-white">
            <span className="button-text">Add Employee {selected.length > 1 ? '(s)' : null} </span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default AddEmployeeModal



// WEBPACK FOOTER //
// ./src/components/WmDispatch/AddEmployeeModal.js